// extracted by mini-css-extract-plugin
module.exports = {"container":"page-header_container__1RtK9","logoContainer":"page-header_logoContainer__2YLrD"};